import './style.scss';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Radio } from '@src/global/components/ActiveForm/Elements/Radio';

import { PreviewDeliveryOption } from '@global/utils/orderUtils';
import { dateFormatter } from '@global/utils/date';

import { LOCALE_CODES } from '@global/types/types';

interface DeliveryOptionsProps {
  handleSelect: (id: string) => void;
  options: PreviewDeliveryOption[] | null;
  selectedId?: string;
}

export const DeliveryOptions: FC<DeliveryOptionsProps> = (props) => {
  const { t, i18n } = useTranslation();

  const formatDate = (date: string) =>
    dateFormatter(date, i18n.language as LOCALE_CODES, {
      day: 'numeric',
      month: 'short',
      weekday: 'long',
    });

  return (
    <>
      <p className="delivery-options__title">
        {t('checkout.shippingAddress.deliveryOptions')}
      </p>
      <p className="delivery-options__description">
        {t('checkout.shippingAddress.deliveryDescription')}
      </p>
      <ul className="delivery-options__list">
        {props.options.map((option) => {
          return (
            <li key={option.id} className="delivery-options__item">
              <Radio
                onChange={() => props.handleSelect(option.id)}
                id={option.id}
                checked={option.id === props.selectedId}
              >
                <span className="delivery-options__item-content">
                  <span className="item-content__title">
                    <span className="item-content__title-price">
                      {option.isFreeShipping
                        ? t('checkout.shippingAddress.free')
                        : option.price}
                    </span>
                    <span> - </span>
                    <span className="item-content__title-date">
                      {formatDate(option.date.to)}
                    </span>
                  </span>
                  <span className="item-content__description">
                    {option.title}
                  </span>
                </span>
              </Radio>
            </li>
          );
        })}
      </ul>
    </>
  );
};
